<!--
 * @Description: 项目根组件
 -->
<template>
  <div id="app" name="app">
    <el-container>
      <!-- 顶部导航栏 -->
<!--      <div class="topbar"></div>-->
      <!-- 顶部导航栏END -->

      <!-- 顶栏容器 -->
      <el-header :class="{ 'home-header': true, 'home-header-fixed': show }">
        <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            active-text-color="#fff"
            text-color="#555555"
            router
            @select="handleSelect"
        >
          <div class="navbar-header">
            <div class="">
              <router-link to="/">
                <img src="./assets/imgs/kss_logo.png" alt style="margin: 10px;width: 100px"/>
              </router-link>
            </div>
            <div class="navbar-buttons">
              <span class="navbar-toggle">
                <i class="el-icon-s-operation" @click="changeMenu"></i>
              </span>
            </div>
          </div>
          <transition name="slide"  >
            <div class="navbar-collapse" v-if="isCollapse">
              <div class="header-ul">
                <el-menu-item index="brochure" style="height: 100%"><span>BROCHURE</span> </el-menu-item>
                <el-menu-item index="/" style="height: 100%"><span>PRODUCT</span> </el-menu-item>
<!--                <el-menu-item index="home" style="height: 100%"><span>HOME</span></el-menu-item>-->
               <!-- <el-menu-item index="services" style="height: 100%"><span>SERVICES</span></el-menu-item> -->
<!--                <el-menu-item index="FAQ" style="height: 100%"><span>FAQ</span></el-menu-item>-->
                <el-menu-item index="contact" style="height: 100%"><span>CONTACT</span></el-menu-item>
                <el-menu-item index="login" v-if="!islogin"><span style="text-decoration: none !important">Login</span></el-menu-item>
                <div class="country-selector" v-if="!islogin">
                  <el-dropdown class="country-selector__dropdown" placement="bottom-end">
                    <span class="el-dropdown-link country-selector__trigger" aria-label="Select country">
                      <span class="country-flag-frame">
                        <img class="country-flag" :src="chooseImg" v-if="chooseImg" alt=""/>
                      </span>
                      <i class="el-icon-arrow-down el-icon--right" aria-hidden="true"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" class="country-dropdown-menu">
                      <el-dropdown-item @click.native="changeCountry(americaImg,'price_america')">
                        <span class="country-option">
                          <span class="country-flag-frame">
                            <img class="country-flag" :src="americaImg" v-if="americaImg" alt=""/>
                          </span>
                          <span class="country-option__label">America</span>
                        </span>
                      </el-dropdown-item>
                      <el-dropdown-item @click.native="changeCountry(canadaImg,'price_canada')">
                        <span class="country-option">
                          <span class="country-flag-frame">
                            <img class="country-flag" :src="canadaImg" v-if="canadaImg" alt=""/>
                          </span>
                          <span class="country-option__label">Canada</span>
                        </span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div v-if="islogin" class="account-tools">
                  <el-dropdown>
                    <span class="el-dropdown-link" style="font-weight: bold;margin-left: 20px">
                      {{ nickname }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="tofootmark()">footmark</el-dropdown-item>
                      <el-dropdown-item @click.native="tocollect()">Collect</el-dropdown-item>
                      <el-dropdown-item @click.native="tocatalogue()">Catalogue</el-dropdown-item>
<!--                                      <el-dropdown-item @click.native="tofeedback()">Contact</el-dropdown-item>-->
                      <el-dropdown-item @click.native="logout()">logout</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-dropdown class="country-selector__dropdown" placement="bottom-end">
                    <span class="el-dropdown-link country-selector__trigger" aria-label="Select country">
                      <span class="country-flag-frame">
                        <img class="country-flag" :src="chooseImg" v-if="chooseImg" alt=""/>
                      </span>
                      <i class="el-icon-arrow-down el-icon--right" aria-hidden="true"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" class="country-dropdown-menu">
                      <el-dropdown-item @click.native="changeCountry(americaImg,'price_america')">
                        <span class="country-option">
                          <span class="country-flag-frame">
                            <img class="country-flag" :src="americaImg" v-if="americaImg" alt=""/>
                          </span>
                          <span class="country-option__label">America</span>
                        </span>
                      </el-dropdown-item>
                      <el-dropdown-item @click.native="changeCountry(canadaImg,'price_canada')">
                        <span class="country-option">
                          <span class="country-flag-frame">
                            <img class="country-flag" :src="canadaImg" v-if="canadaImg" alt=""/>
                          </span>
                          <span class="country-option__label">Canada</span>
                        </span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
          </transition>
        </el-menu>
      </el-header>
      <!-- 顶栏容器END -->

      <!-- 登录模块 -->
      <MyLogin></MyLogin>
      <!-- 注册模块 -->
      <MyRegister :register="register" @fromChild="isRegister"></MyRegister>

      <!-- 主要区域容器 -->
      <el-main>
        <keep-alive>
          <router-view v-if="$route.meta.isKeepAlive=='isBack'"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.isKeepAlive || $route.meta.isKeepAlive===''"></router-view>
      </el-main>
      <!-- 主要区域容器END -->

      <!-- 底栏容器 -->
      <el-footer class="site-footer-shell">
        <footer class="site-footer" aria-label="Website footer">
          <div class="site-footer__main" :style="footerBackgroundStyle">
            <div class="site-footer__inner">
              <div class="site-footer__navigation">
                <section class="site-footer__group site-footer__categories" aria-labelledby="footer-categories-title">
                  <h2 id="footer-categories-title">All Categories</h2>
                  <nav aria-label="Product categories">
                    <ul>
                      <li v-for="category in footerCategories" :key="category.value">
                        <router-link
                            :to="getCategoryLink(category)"
                            :aria-label="'Browse ' + category.label"
                        >
                          {{ category.label }}
                        </router-link>
                      </li>
                    </ul>
                  </nav>
                </section>

                <section class="site-footer__group" aria-labelledby="footer-services-title">
                  <h2 id="footer-services-title">Shop &amp; Services</h2>
                  <nav aria-label="Shop and services">
                    <ul>
                      <li><router-link :to="{ path: '/product-list', query: { is_rush: '0' } }">All Products</router-link></li>
                      <li><router-link :to="{ path: '/product-list', query: { is_rush: '1' } }">Ready to Ship</router-link></li>
                      <li><router-link to="/">Featured Products</router-link></li>
                      <li><router-link to="/brochure">Digital Brochures</router-link></li>
                      <li><router-link to="/contact">Contact Our Team</router-link></li>
                    </ul>
                  </nav>
                </section>

                <section class="site-footer__group" aria-labelledby="footer-support-title">
                  <h2 id="footer-support-title">Support &amp; Account</h2>
                  <nav aria-label="Support and account">
                    <ul>
                      <li><router-link to="/login">Sign In</router-link></li>
                      <li><router-link to="/collect">Saved Products</router-link></li>
                      <li><router-link to="/catalogue">My Catalogue</router-link></li>
                      <li><router-link to="/footmark">Browsing History</router-link></li>
                      <li><router-link to="/faq">Frequently Asked Questions</router-link></li>
                    </ul>
                  </nav>
                </section>
              </div>

              <aside class="site-footer__memberships" aria-label="Membership logos">
                <div class="site-footer__badge-list">
                  <figure v-for="badge in footerBadges" :key="badge.src" class="site-footer__badge">
                    <img
                        v-if="badge.src"
                        v-lazy="badge.src"
                        :alt="badge.name"
                        width="320"
                        height="100"
                    />
                    <div
                        v-else
                        class="site-footer__badge-placeholder"
                        role="img"
                        :aria-label="badge.name + ' image placeholder'"
                    >
                      <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
                        <path d="M12 3.75 14.55 9l5.7.82-4.12 4.02.97 5.68L12 16.84l-5.1 2.68.97-5.68-4.12-4.02L9.45 9 12 3.75Z" />
                      </svg>
                    </div>
                  </figure>
                </div>
              </aside>
            </div>
          </div>

          <div class="site-footer__bottom">
            <div class="site-footer__bottom-inner">
              <p>{{ config.footer_left || `© ${currentYear} KSUPPLYS. All rights reserved.` }}</p>
              <div v-if="footerRightContent" class="site-footer__legal" v-html="footerRightContent"></div>
              <router-link v-else to="/contact">Contact Us</router-link>
            </div>
          </div>
        </footer>
      </el-footer>
      <!-- 底栏容器END -->
    </el-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import { getHomeData } from "@/api/home.js";
import { categoryThemeList } from "@/api/product.js";

export default {
  mounted() {
    // 监听页面滚动事件
    window.addEventListener("scroll", this.showSearch);
    this.token = localStorage.getItem("token");
    if (this.token && this.token != "") {
      this.islogin = true;
      this.nickname = localStorage.getItem("nickname");
    } else {
      this.islogin = false;
    }

    let price_type = localStorage.getItem("price_type");
    if (price_type == "price_canada") {
      this.chooseImg = this.canadaImg;
    } else {
      this.chooseImg = this.americaImg;
    }
    this.getHomeList();
    this.getFooterCategories();
  },
  beforeUpdate() {
    this.activeIndex = "0";
  },
  data() {
    return {
      nickname: "",
      islogin: false,
      token: "",
      show: false,
      activeIndex: "0", // 头部导航栏选中的标签
      search: "", // 搜索条件
      register: false, // 是否显示注册组件
      visible: false, // 是否退出登录
      isCollapse: false, // 是否展示下拉
      config:{},
      footerCategories: [
        { value: 1, label: "Apparel & Outerwear" },
        { value: 5, label: "Bags & Luggage" },
        { value: 6, label: "Caps & Hats" },
        { value: 7, label: "Drinkware" },
        { value: 8, label: "Electronics & Tech Products" },
        { value: 9, label: "Health & Wellness" },
        { value: 11, label: "Home & Garden" },
        { value: 14, label: "Kitchen & Dining" },
        { value: 20, label: "School, Office & Craft Supplies" },
        { value: 22, label: "Sports, Fitness & Outdoors" },
      ],
      chooseImg:require("@/assets/imgs/america.png"),
      americaImg: require("@/assets/imgs/america.png"),
      canadaImg: require("@/assets/imgs/canada.png"),
    };
  },
  created() {
    // 获取浏览器localStorage，判断用户是否已经登录
    if (localStorage.getItem("token")) {
      // 如果已经登录，设置vuex登录状态
      this.setUser(localStorage.getItem("token"));
    }
    this.isCollapse = false
    if(window.screen.width>768) {
      this.isCollapse = true
    }else {
      this.isCollapse = false
    }
  },
  computed: {
    ...mapGetters(["getUser", "getNum"]),
    currentYear() {
      return new Date().getFullYear();
    },
    footerBadges() {
      const logos = this.config.footer_logos;
      return Array.isArray(logos) && logos.length
          ? logos.slice(0, 3).map((src, index) => ({ name: `Membership logo ${index + 1}`, src }))
          : [];
    },
    footerBackgroundStyle() {
      const image = this.config.footer_background;
      return image ? {
        backgroundImage: `linear-gradient(105deg, rgba(5, 19, 34, 0.68) 0%, rgba(7, 27, 47, 0.5) 62%, rgba(5, 18, 33, 0.68) 100%), url(${JSON.stringify(image)})`,
      } : {};
    },
    footerRightContent() {
      const content = this.config.footer_right || "";
      return content.replace(/<br\s*\/?\s*>/gi, "").trim() ? content : "";
    },
  },
  watch: {
    // 获取vuex的登录状态
    getUser: function (val) {
      if (val === "") {
        // 用户没有登录
        this.setShoppingCart([]);
      } else {
        // 用户已经登录,获取该用户的购物车信息
        this.islogin = true;
        this.nickname = localStorage.getItem("nickname");
      }
    },
  },
  methods: {
    ...mapActions(["setUser", "setShowLogin", "setShoppingCart"]),
    login() {
      // 点击登录按钮, 通过更改vuex的showLogin值显示登录组件
      this.setShowLogin(true);
    },
    handleSelect() {
      if(window.screen.width>768) {
        this.isCollapse = true
      }else {
        this.isCollapse = false
      }
    },
    // 退出登录
    logout() {
      this.visible = false;
      // 清空本地登录信息
      localStorage.setItem("token", "");
      // 清空vuex登录信息
      this.setUser("");
      this.islogin = false;
      if(window.screen.width>768) {
        this.isCollapse = true
      }else {
        this.isCollapse = false
      }
      this.notifySucceed("成功退出登录");
      this.$router.go(0)
    },
    getHomeList() {
      getHomeData().then((res) => {
        const {config } = res.data;
        this.config = config;
      });
    },
    getFooterCategories() {
      const preferredCategoryIds = [1, 5, 6, 7, 8, 9, 11, 14, 20, 22];

      categoryThemeList().then((res) => {
        const categories = res.data.category || [];
        const selectedCategories = preferredCategoryIds
            .map((id) => categories.find((category) => Number(category.value) === id))
            .filter(Boolean);

        if (selectedCategories.length) {
          this.footerCategories = selectedCategories;
        }
      }).catch(() => {
        // Keep the built-in category links available if the API is temporarily unavailable.
      });
    },
    getCategoryLink(category) {
      return {
        path: "/product-list",
        query: {
          category: [String(category.value)],
          is_rush: "0",
        },
      };
    },
    // 接收注册子组件传过来的数据
    isRegister(val) {
      this.register = val;
    },
    // 点击搜索按钮
    searchClick() {
      if (this.search != "") {
        // 跳转到全部商品页面,并传递搜索条件
        this.$router.push({ path: "/goods", query: { search: this.search } });
        this.search = "";
      }
    },
    showSearch() {
      let scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 40) {
        // 当页面滚动到高度300px处，动态绑定class 来设置头部固定定位
        this.show = true;
      } else {
        this.show = false;
      }
    },
    changeCountry(img,price_type) {
      this.chooseImg = img;
      localStorage.setItem("price_type",price_type);
    },
    changeMenu() {
      this.isCollapse = !this.isCollapse
    },
    toproduct() {
      this.$router.push({ path: "/" });
    },
    tofootmark() {
      this.$router.push({
        path: "footmark",
      });
      if(window.screen.width>768) {
        this.isCollapse = true
      }else {
        this.isCollapse = false
      }
    },
    tocollect() {
      this.$router.push({
        path: "collect",
      });
      if(window.screen.width>768) {
        this.isCollapse = true
      }else {
        this.isCollapse = false
      }
    },
    tocatalogue() {
      this.$router.push({
        path: "catalogue",
      });
      if(window.screen.width>768) {
        this.isCollapse = true
      }else {
        this.isCollapse = false
      }
    },
    tofeedback() {
      this.$router.push({
        path: "feedback",
      });
      if(window.screen.width>768) {
        this.isCollapse = true
      }else {
        this.isCollapse = false
      }
    },
  },
};
</script>
<style lang="scss">
@import "assets/css/index";

html,
body {
  width: 100%;
  min-height: 100%;
  margin: 0;
}

body {
  min-width: 320px;
}

#app,
#app > .el-container {
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
}

#app > .el-container {
  flex-direction: column;
}

#app > .el-container > .el-main {
  flex: 1 0 auto;
  width: 100%;
  overflow: visible;
}

#app > .el-container > .el-footer {
  flex: 0 0 auto;
  width: 100%;
}

.country-dropdown-menu.el-dropdown-menu {
  min-width: 136px;
  padding: 6px 0;
}

.country-dropdown-menu .el-dropdown-menu__item {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 14px;
  line-height: 1;
}

.country-option {
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr);
  align-items: center;
  column-gap: 8px;
  width: 100%;
}

.country-option__label {
  line-height: 20px;
  white-space: nowrap;
}

.country-flag-frame {
  display: inline-flex;
  flex: 0 0 30px;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 20px;
  overflow: hidden;
}

.country-flag {
  display: block;
  width: 100%;
  height: 100%;
  margin: 0;
  object-fit: contain;
}
</style>
<style scoped>
/* 覆盖Element UI的默认样式 */
.el-menu-item.is-active {
  background-color: #38a7bb !important; /* 你想要的颜色 */
  text-decoration: none;
}
.el-menu.el-menu--horizontal {
  border: none !important;
}
.el-menu--horizontal > .el-menu-item.is-active span {
  border-bottom: none !important;
}
.el-menu-item span {
  text-transform: uppercase;
  text-decoration: underline;
  font-weight: bold;
}
/* .caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid\9;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
} */
.el-submenu {
  text-transform: uppercase;
  text-decoration: underline;
  font-weight: bold !important;
}
.el-submenu__icon-arrow {
  display: none !important;
}
.el-submenu__title * {
  vertical-align: unset !important;
}
.el-menu-demo {
  --hover-color: #f0f9ff !important; /* 自定义悬浮颜色变量 */
}

.header-ul > div {
  display: flex;
  align-items: center;
  min-height: 60px;
  line-height: 1 !important;
}

.header-ul > div > .el-dropdown {
  display: inline-flex;
  align-items: center;
  min-height: 60px;
  vertical-align: middle;
}

.header-ul .el-dropdown-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  line-height: 1.2;
}

.country-selector__dropdown {
  margin-left: 20px;
}

.header-ul .country-selector__trigger {
  min-height: 60px;
  padding: 0 4px;
  font-weight: bold;
  cursor: pointer;
}

.header-ul .country-selector__trigger .country-flag {
  display: block;
  width: 100% !important;
  height: 100%;
  margin: 0 !important;
  object-fit: contain;
}

.header-ul .el-dropdown-link .el-icon--right {
  margin-left: 0;
}

.el-menu-item:hover {
  background-color: rgb(
      56 167 187 / 60%
  ) !important; /* 使用变量设置悬浮背景色 */
}
.el-submenu .el-submenu__title:hover {
  background-color: rgb(
      56 167 187 / 60%
  ) !important; /* 使用变量设置悬浮背景色 */
}
::v-deep .el-submenu__title i {
  font-weight: bold !important;
  color: #333 !important;
}

.site-footer-shell {
  position: static !important;
  flex-shrink: 0;
  height: auto !important;
  padding: 0 !important;
}

.site-footer {
  --footer-accent: #63c7d5;
  --footer-surface: #081725;
  --footer-surface-deep: #06111e;
  --footer-text: #dce7ef;
  --footer-muted: #b7c7d4;
  --footer-border: rgba(255, 255, 255, 0.16);
  width: 100%;
  color: var(--footer-text);
  background: var(--footer-surface);
  font-family: "Open Sans", Arial, sans-serif;
}

.site-footer__main {
  position: relative;
  background-image:
      linear-gradient(105deg, rgba(5, 19, 34, 0.68) 0%, rgba(7, 27, 47, 0.5) 62%, rgba(5, 18, 33, 0.68) 100%),
      url("./assets/imgs/foot_bg.jpg");
  background-position: center;
  background-size: cover;
}

.site-footer__inner {
  display: grid;
  grid-template-columns: minmax(0, 3fr) minmax(280px, 0.92fr);
  gap: 64px;
  width: min(100% - 48px, 1220px);
  margin: 0 auto;
  padding: 48px 0 44px;
}

.site-footer__navigation {
  display: grid;
  grid-template-columns: minmax(250px, 1.35fr) repeat(2, minmax(190px, 1fr));
  gap: 48px;
  min-width: 0;
}

.site-footer__group h2 {
  margin: 0 0 16px;
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.35;
}

.site-footer__group ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.site-footer__group li + li {
  margin-top: 2px;
}

.site-footer__group a {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  color: var(--footer-muted);
  font-size: 15px;
  line-height: 1.45;
  text-decoration: none;
  transition: color 180ms ease-out, transform 180ms ease-out;
}

.site-footer__group a:focus-visible,
.site-footer__bottom a:focus-visible {
  border-radius: 2px;
  outline: 3px solid var(--footer-accent);
  outline-offset: 3px;
}

.site-footer__memberships {
  min-width: 0;
  transform: translateX(clamp(0px, calc(50vw - 632px), 210px));
}

.site-footer__badge-list {
  display: grid;
  gap: 12px;
}

.site-footer__badge {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-height: 86px;
  margin: 0;
}

.site-footer__badge img {
  width: auto;
  max-width: 100%;
  height: 86px;
  padding: 0;
  background: transparent;
  object-fit: contain;
  object-position: right center;
}

.site-footer__badge-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-width: 0;
  padding: 16px;
  color: #e8f2f7;
  border: 1px dashed rgba(255, 255, 255, 0.3);
}

.site-footer__badge-placeholder svg {
  fill: none;
  stroke: var(--footer-accent);
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.6;
}

.site-footer__bottom {
  background: var(--footer-surface-deep);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.site-footer__bottom-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  width: min(100% - 48px, 1220px);
  min-height: 56px;
  margin: 0 auto;
  color: #c8d6e0;
  font-size: 13px;
  line-height: 1.5;
}

.site-footer__bottom p {
  margin: 0;
}

.site-footer__bottom a {
  color: #dce7ef;
  text-decoration: none;
  transition: color 180ms ease-out;
}

.site-footer__legal {
  text-align: right;
}

@media (hover: hover) {
  .site-footer__group a:hover {
    color: #ffffff;
    transform: translateX(3px);
  }

  .site-footer__bottom a:hover {
    color: var(--footer-accent);
  }
}

@media (max-width: 1024px) {
  .site-footer__inner {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .site-footer__memberships {
    padding-left: 0;
    border-left: 0;
  }

  .site-footer__badge-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .site-footer__group a {
    min-height: 44px;
  }
}

@media (max-width: 720px) {
  .site-footer__inner,
  .site-footer__bottom-inner {
    width: min(100% - 32px, 1220px);
  }

  .site-footer__inner {
    padding: 40px 0;
  }

  .site-footer__navigation {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 36px 32px;
  }

  .site-footer__categories {
    grid-column: 1 / -1;
  }

  .site-footer__categories ul {
    columns: 2;
    column-gap: 32px;
  }

  .site-footer__categories li {
    break-inside: avoid;
  }

  .site-footer__group a {
    min-height: 44px;
    font-size: 16px;
  }

  .site-footer__badge-list {
    grid-template-columns: 1fr;
  }

  .site-footer__bottom-inner {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
    padding: 16px 0;
  }

  .site-footer__legal {
    text-align: left;
  }
}

@media (max-width: 480px) {
  .site-footer__main {
    background-image: linear-gradient(160deg, #071a2d 0%, #06111e 100%);
  }

  .site-footer__navigation {
    grid-template-columns: 1fr;
  }

  .site-footer__categories {
    grid-column: auto;
  }

  .site-footer__categories ul {
    columns: 1;
  }

  .site-footer__group:not(:last-child) {
    padding-bottom: 24px;
    border-bottom: 1px solid var(--footer-border);
  }
}

@media (prefers-reduced-motion: reduce) {
  .site-footer__group a,
  .site-footer__bottom a {
    transition: none;
  }
}

</style>
